import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
     faCheck,
    faGaugeHigh, faCalendarDays, faInfinity,
    faBolt, faMicrochip, faShieldHalved, faClipboardCheck,
    faLock, faGraduationCap, faFingerprint
} from '@fortawesome/free-solid-svg-icons';

import aiStudioImg from '../../assets/images/AI_Studio.png';
import aiStudioIcon from '../../assets/images/AI_Studiio-32x32.png';
import cognitionImg from '../../assets/images/Congition-Full.png';
import cognitionIcon from '../../assets/images/Congition-32x32.png';
import agentdogImg from '../../assets/images/Doctor-Dog-Use-Case.png';
import agentDogIcon from '../../assets/images/agentDOG-32x32.png';

const products = [
    {
        name: 'Nebulyx AI Studio',
        tag: 'Rapid AI Prototyping & Simulation',
        icon: aiStudioIcon,
        color: '#7030A0',
        image: aiStudioImg,
        features: [
            'AI builds 60–80% of workflows, your team validates',
            'Classical AI, gen AI, and scenario engines - all built in',
            '3–4 week delivery, data integration + security included',
            'Unlimited what-if scenarios before going live',
        ],
        matter: 'A working AI platform in weeks, not months. Your stakeholders get a live tool, not a report.',
        stats: [
            { icon: faGaugeHigh, color: '#c084fc', value: '60–80%', label: 'AI-Built' },
            { icon: faCalendarDays, color: '#60a5fa', value: '3–4 wks', label: 'To Pilot' },
            { icon: faInfinity, color: '#34d399', value: '∞', label: 'Scenarios' },
        ],
    },
    {
        name: 'Nebulyx Cognition',
        tag: 'Expert Reasoning, Automated',
        icon: cognitionIcon,
        // isFaIcon: true,
        color: '#003366',
        image: cognitionImg,
        features: [
            "Consistent(Pat. Pend.) AI, Language model that is typically less than 1GB that runs anywhere",
            'Zero hallucination - only cites loaded documents, not guesses',
            '100% Consistent- same question, same answer, always',
            '50ms response, no API costs, full UK data sovereignty',
        ],
        matter: 'Expert-level decisions at scale - without the expert bottleneck. In production today.',
        stats: [
            { icon: faBolt, color: '#c084fc', value: '50ms', label: 'Response' },
            { icon: faMicrochip, color: '#60a5fa', value: '> 1GB', label: 'Model' },
            { icon: faShieldHalved, color: '#f87171', value: 'Zero', label: 'Hallucination' },
            { icon: faClipboardCheck, color: '#34d399', value: '100%', label: 'Auditable' },
        ],
    },
    {
        name: 'Nebulyx AgentDOG',
        tag: 'Intelligent Agents, Governed',
        icon: agentDogIcon,
        color: '#2f5597',
        image: agentdogImg,
        features: [
            'Agents learn from real decisions with Consistentguardrails',
            'Expert overrides captured - the system gets smarter every time',
            'Semantic reasoning, execution policies, context management',
            "For complex ops, knowledge management, risk - where rules aren't fixed",
        ],
        matter: 'AI that learns from your experts - without losing control. Smarter with every use.',
        stats: [
            { icon: faLock, color: '#c084fc', value: 'Governed', label: 'Agents' },
            { icon: faGraduationCap, color: '#60a5fa', value: 'Continuous', label: 'Learning' },
            { icon: faFingerprint, color: '#34d399', value: 'Full', label: 'Provenance' },
        ],
    },
];

const ProductsSection = () => (
    <section id="products" className="what-is-section">
        <Container>
            <div className="section-label">Product Suite</div>
            <h2>Three Products. One Platform.</h2>

            {products.map((p, idx) => (
                <div className={`product-row ${idx % 2 === 1 ? 'product-row-reverse' : ''}`} key={idx}>
                    {/* Left: Image */}
                    <div className="product-row-visual">
                        <div className="product-row-header" style={{ background: p.color }}>
                            <div className="product-card-header-orb" />
                            <div className="product-card-header-inner">
                                <div className="product-card-icon-box">
                                    <img src={p.icon} width={56} height={56} alt="" />
                                </div>
                                <div>
                                    <div className="product-card-name">{p.name}</div>
                                    <div className="product-card-tag pt-2 pb-2">{p.tag}</div>
                                </div>
                            </div>
                        </div>
                        <div className="product-row-image">
                            <img src={p.image} alt={p.name} />
                        </div>
                    </div>

                    {/* Right: Content */}
                    <div className="product-row-content">
                        {/* Features */}
                        <div className="product-card-features">
                            {p.features.map((f, i) => (
                                <div className="product-card-feat" key={i}>
                                    <span className="product-card-check" style={{ background: p.color + '10' }}>
                                        <FontAwesomeIcon icon={faCheck} style={{ color: p.color }} />
                                    </span>
                                    <span>{f}</span>
                                </div>
                            ))}
                        </div>

                        {/* Why it matters */}
                        <div className="product-card-matter" style={{ borderLeftColor: p.color, background: p.color + '06' }}>
                            <div className="product-card-matter-label" style={{ color: p.color + '90' }}>Why it matters</div>
                            <div className="product-card-matter-text">{p.matter}</div>
                        </div>

                        {/* Stats */}
                        <div className="product-card-stats" style={{ gridTemplateColumns: `repeat(${p.stats.length}, 1fr)` }}>
                            {p.stats.map((s, i) => (
                                <div className="product-card-stat" key={i}>
                                    <FontAwesomeIcon icon={s.icon} className="product-card-stat-icon" style={{ color: s.color }} />
                                    <div className="product-card-stat-value">{s.value}</div>
                                    <div className="product-card-stat-label">{s.label}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </Container>
    </section>
);

export default ProductsSection;